__turbopack_context__.v({
  "className": "cormorant_garamond_72789b49-module__yNJ71W__className",
});
